import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMutation, useApolloClient } from "@apollo/client";
import { JWT } from "~/apollo/_config";
import { WORKSPACE_AUTHORIZATION_MUTATION, CURRENT_USER_QUERY } from "~/api";
import SplashScreen from "~/components/general/SplashScreen";
import { toast } from "react-toastify";
import Toast, { TOAST_TYPES } from "@shared/ui/Toast";

type Props = {};

const WorkspaceAuthorization = (props: Props) => {
  const { id } = useParams<{ id: string }>();
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const navigate = useNavigate();

  const authToken = localStorage.getItem(JWT.LOCAL_STORAGE.TOKEN.NAME);

  const client = useApolloClient();
  const [workspaceAuthorization, _] = useMutation(
    WORKSPACE_AUTHORIZATION_MUTATION,
  );

  useEffect(() => {
    if (authToken && token) {
      workspaceAuthorization({
        variables: {
          input: {
            token,
          },
        },
      })
        .then(async () => {
          await client.refetchQueries({ include: [CURRENT_USER_QUERY] }); //To update user portal data
          navigate(`/app/workspace/${id}`);
        })
        .catch((err) => {
          toast(<Toast message={err.message} type={TOAST_TYPES.ERROR} />, {
            closeButton: false,
          });
          navigate("/app");
        });
    } else if (!authToken) {
      const redirectUrl = `/oem?redirect=${encodeURIComponent(
        `/workspace/authorization/${id}?token=${token}`,
      )}`;
      navigate(redirectUrl);
    }
  }, [token, workspaceAuthorization, authToken]);

  return <SplashScreen />;
};

export default WorkspaceAuthorization;
